/**
 * Created by jv on 16/01/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");
const User = require("Sources/models/user");
const Error = require("Sources/models/error");
const ProfileSubscriptionGuest = require("Sources/models/profile-subscription-guest");

var profileServices = {};

(function(ProfileServices)
{
  function dataToError(data, callback)
  {
    if(utils.isFunction(callback))
    {
      if(data.hasOwnProperty("exception"))
      {
        callback(new Error(data.exception));
      }
      else
      {
        callback(new Error({
          code: null,
          message: null
        }));
      }
    }
  }

  ProfileServices.getLoggedInUser = function(username, password, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("login_profile"),
      cache: false,
      dataType: "json",
      data: {
        username: username,
        password: password
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new User(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  ProfileServices.getProfileFromUserKey = function(userKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_profile_by_userkey"),
      cache: false,
      dataType: "json",
      data: {
        "user-key": userKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new User(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  ProfileServices.resetPassword = function(username, successCb, failCb)
  {
    request.post({
      url:  utils.getServiceUrl("reset_password"),
      cache: false,
      dataType: "json",
      data: {
        username: username
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  ProfileServices.changePassword = function(username, ticket, passwordOld, passwordNew, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("change_password"),
      cache: false,
      dataType: "json",
      data: {
        "username": username,
        "ticket": ticket,
        "password-old": passwordOld,
        "password-new": passwordNew
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  ProfileServices.updateProfile = function(profileData, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url: utils.getServiceUrl("update_profile"),
      cache: false,
      dataType: "json",
      data: {
        "user-key": profileData.userKey,
        firstname: profileData.firstname,
        lastname: profileData.lastname,
        locale: profileData.locale,
        newsletter: profileData.newsletter === true ? "1" : "0"
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new User(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  ProfileServices.updateIncompleteProfile = function(profileData, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url: utils.getServiceUrl("update_incomplete_profile"),
      cache: false,
      dataType: "json",
      data: {
        "user-key": profileData.userKey,
        ticket: profileData.ticket,
        firstname: profileData.firstname,
        lastname: profileData.lastname,
        locale: profileData.locale,
        "password-new": profileData.password,
        newsletter: profileData.newsletter === true ? "1" : "0"
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  ProfileServices.registerProfile = function(profileData, successCb, failCb)
  {
    request.post({
      url: utils.getServiceUrl("register_profile"),
      cache: false,
      dataType: "json",
      data: {
        email: profileData.email,
        firstname: profileData.firstname,
        lastname: profileData.lastname,
        locale: profileData.locale,
        password: profileData.password
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  ProfileServices.verifyEmail = function(code, successCb, failCb)
  {
    request.post({
      url: utils.getServiceUrl("verify_email"),
      cache: false,
      dataType: "json",
      data: {
        code: code
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  ProfileServices.getProfileSubscriptionGuests = function(profileKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("get_profile_subscription_guests"),
        cache: false,
        dataType: "json",
        data: {
          "profile-key": profileKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var guests = [];

          if(data.result.result.hasOwnProperty("profile-subscription-guest-list"))
          {
            for(var i = 0; i < data.result.result["profile-subscription-guest-list"].length; i++)
            {
              guests.push(new ProfileSubscriptionGuest(data.result.result["profile-subscription-guest-list"][i]));
            }
          }

          successCb(guests);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  ProfileServices.requestDeleteProfile = function(successCb, failCb)
  {
    ProfileServices.deleteProfile(null, successCb, failCb);
  };

  ProfileServices.deleteProfile = function(ticket, successCb, failCb)
  {
    var commandData = {};

    if(ticket !== null && ticket !== undefined && ticket !== "")
    {
      commandData.ticket = ticket;
    }


    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("delete_profile"),
      cache: false,
      dataType: "json",
      data: commandData
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

}(profileServices));

module.exports = profileServices;



// WEBPACK FOOTER //
// ./app/js/services/fundels/profile-services.js